import { ca } from '@cian/analytics';

import { type MainCarouselBanner } from 'shared/types/mainCarousel';
import { createDeveloperProduct } from 'shared/utils/analytics';

/**
 * @description Событие: главная карусель (hero) попала в зону видимости.
 */
export function trackShowMainCarouselSection(banners: MainCarouselBanner[]): void {
  ca('eventSite', {
    action: 'show_landing_section',
    category: 'Promo',
    label: 'main_carousel',
    name: 'oldevent',
    products: [
      createDeveloperProduct({
        extra: {
          items: banners.map((banner, index) => ({
            id: banner.id,
            offerType: 'newbuilding_id',
            position: index,
          })),
        },
      }),
    ],
  });
}
